/**
 * @author Erik Vroon
 * @copyright Erik Vroon
 * @license Dutch authorship law (auteursrecht). The animation work is protected by Dutch and European copyright law. Publishing or ingesting this into large language model is allowed only with the original author's consent. There may be packages used with their own licenses.
 * 
 */
import { html } from "lit";
import { SvgAnimationComponent } from "./svg-animation.component";

export class Uutje404SvgAnimationComponent extends SvgAnimationComponent {
    // an array of objects containing assets.
    // also possible: styles sub-object with marginLeft, marginTop, transform rotateY
    frameObjects = [
        {
            asset: `./svg/uutje-404/svg/Uutje404 (2).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (2).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (2).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (2).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (2).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (2).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (3).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (3).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (3).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (4).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (6).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (6).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (6).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (6).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (6).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (7).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (7).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (7).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (8).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (8).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (8).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (8).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (9).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (9).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (9).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (10).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (11).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (12).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (12).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (12).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (11).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (11).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (13).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (13).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (13).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },

        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (18).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (18).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (19).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (20).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (20).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (20).svg`,
        },
        // walk initial
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (13).svg`,
            styles: {
                marginLeft: 2,
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (12).svg`,
            styles: {
                marginLeft: 2,
            }
        },
        // walk loop
        // start start
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
            styles: {
                marginLeft: 8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (4).svg`,
            styles: {
                marginLeft: 8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (5).svg`,
            styles: {
                marginLeft: 8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (8).svg`,
            styles: {
                marginLeft: 1
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
            styles: {
                marginLeft: 8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (4).svg`,
            styles: {
                marginLeft: 8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (5).svg`,
            styles: {
                marginLeft: 8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (8).svg`,
            styles: {
                marginLeft: 1
            }
        },

        // walk loop
        // start start
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
            styles: {
                marginLeft: 8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (4).svg`,
            styles: {
                marginLeft: 8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (5).svg`,
            styles: {
                marginLeft: 8
            }
        },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (6).svg`,
        // 	styles: {
        // 		marginLeft: 1
        // 	}
        // },

        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (9).svg`,
        // 	styles: {
        // 		marginLeft: 1
        // 	}
        // },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (8).svg`,
            styles: {
                marginLeft: 1
            }
        },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
        // 	styles: {
        // 		marginLeft: 8
        // 	}
        // },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (10).svg`,
        // 	styles: {
        // 		marginLeft: 2
        // 	}
        // },
        // walk loop again
        // start start
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (15).svg`,
        // },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (17).svg`,
        // },
        // end start
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (2).svg`,
        // 	styles: {
        // 		marginLeft: 2
        // 	}
        // },
        // {
        //     asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (11).svg`,
        //     styles: {
        //         marginLeft: 1
        //     }
        // },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
            styles: {
                marginLeft: 8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (4).svg`,
            styles: {
                marginLeft: 8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (5).svg`,
            styles: {
                marginLeft: 8
            }
        },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (6).svg`,
        // 	styles: {
        // 		marginLeft: 1
        // 	}
        // },

        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (9).svg`,
        // 	styles: {
        // 		marginLeft: 1
        // 	}
        // },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (8).svg`,
            styles: {
                marginLeft: 1
            }
        },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
        // 	styles: {
        // 		marginLeft: 8
        // 	}
        // },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (10).svg`,
        // 	styles: {
        // 		marginLeft: 2
        // 	}
        // },



        // look around again

        {
            asset: `./svg/uutje-404/svg/Uutje404 (2).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (2).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (2).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (3).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (3).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (3).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (4).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (5).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (6).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (6).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (6).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (6).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (6).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (7).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (7).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (7).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (8).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (8).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (8).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (8).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (9).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (9).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (9).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (10).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (11).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (12).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (12).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (12).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (12).svg`,

        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (13).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (13).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (13).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },

        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (14).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (15).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (16).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        }, {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (17).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (18).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (18).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (19).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (20).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (20).svg`,
        },
        {
            asset: `./svg/uutje-404/svg/Uutje404 (20).svg`,
        },


        // walk back
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (13).svg`,
            styles: {
                marginLeft: -2,
                transform: 'rotateY(190deg)'
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (12).svg`,
            styles: {
                marginLeft: -2,
                transform: 'rotateY(190deg)'
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (2).svg`,
            styles: {
                marginLeft: -2,
                transform: 'rotateY(190deg)'
            }
        },


        //

        // start start
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (15).svg`,
        // },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (17).svg`,
        // },
        // end start
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (2).svg`,
        // 	styles: {
        // 		marginLeft: 2
        // 	}
        // },
        // {
        //     asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (11).svg`,
        //     styles: {
        //         marginLeft: -1
        //     }
        // },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
            styles: {
                marginLeft: -8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (4).svg`,
            styles: {
                marginLeft: -8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (5).svg`,
            styles: {
                marginLeft: -8
            }
        },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (6).svg`,
        // 	styles: {
        // 		marginLeft: 1
        // 	}
        // },

        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (9).svg`,
        // 	styles: {
        // 		marginLeft: 1
        // 	}
        // },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (8).svg`,
            styles: {
                marginLeft: -1
            }
        },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
        // 	styles: {
        // 		marginLeft: 8
        // 	}
        // },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (10).svg`,
        // 	styles: {
        // 		marginLeft: 2
        // 	}
        // },


        		// start start
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (15).svg`,
		// },
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (17).svg`,
		// },
		// end start
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (2).svg`,
		// 	styles: {
		// 		marginLeft: 2
		// 	}
		// },
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (11).svg`,
		// 	styles: {
		// 		marginLeft: -1
		// 	}
		// },
		{
			asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
			styles: {
				marginLeft: -8
			}
		},
		{
			asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (4).svg`,
			styles: {
				marginLeft: -8
			}
		},
		{
			asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (5).svg`,
			styles: {
				marginLeft: -8
			}
		},
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (6).svg`,
		// 	styles: {
		// 		marginLeft: 1
		// 	}
		// },

		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (9).svg`,
		// 	styles: {
		// 		marginLeft: 1
		// 	}
		// },
		{
			asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (8).svg`,
			styles: {
				marginLeft: -1
			}
		},
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
		// 	styles: {
		// 		marginLeft: 8
		// 	}
		// },
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (10).svg`,
		// 	styles: {
		// 		marginLeft: 2
		// 	}
		// },

                // start start
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (15).svg`,
        // },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (17).svg`,
        // },
        // end start
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (2).svg`,
        // 	styles: {
        // 		marginLeft: 2
        // 	}
        // },
        // {
        //     asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (11).svg`,
        //     styles: {
        //         marginLeft: -1
        //     }
        // },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
            styles: {
                marginLeft: -8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (4).svg`,
            styles: {
                marginLeft: -8
            }
        },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (5).svg`,
            styles: {
                marginLeft: -8
            }
        },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (6).svg`,
        // 	styles: {
        // 		marginLeft: 1
        // 	}
        // },

        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (9).svg`,
        // 	styles: {
        // 		marginLeft: 1
        // 	}
        // },
        {
            asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (8).svg`,
            styles: {
                marginLeft: -1
            }
        },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
        // 	styles: {
        // 		marginLeft: 8
        // 	}
        // },
        // {
        // 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (10).svg`,
        // 	styles: {
        // 		marginLeft: 2
        // 	}
        // },


        		// start start
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (15).svg`,
		// },
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (17).svg`,
		// },
		// end start
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (2).svg`,
		// 	styles: {
		// 		marginLeft: 2
		// 	}
		// },
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (11).svg`,
		// 	styles: {
		// 		marginLeft: -1
		// 	}
		// },
		{
			asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
			styles: {
				marginLeft: -8
			}
		},
		{
			asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (4).svg`,
			styles: {
				marginLeft: -8
			}
		},
		{
			asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (5).svg`,
			styles: {
				marginLeft: -8
			}
		},
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (6).svg`,
		// 	styles: {
		// 		marginLeft: 1
		// 	}
		// },

		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (9).svg`,
		// 	styles: {
		// 		marginLeft: 1
		// 	}
		// },
		{
			asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (8).svg`,
			styles: {
				marginLeft: -1
			}
		},
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (3).svg`,
		// 	styles: {
		// 		marginLeft: 8
		// 	}
		// },
		// {
		// 	asset: `./svg/uutje-loopt/svg/UutjeLoopt-edited (10).svg`,
		// 	styles: {
		// 		marginLeft: 2
		// 	}
		// },

        {
            asset: `./svg/uutje-404/svg/Uutje404 (2).svg`,
            styles: {
                marginLeft: 0,
                transform: 'rotateY(190deg)'
            }
        },

    ];

    /**
     * Get it into the light DOM, for styling from outside this component
     */
    createRenderRoot() {
        return this;
    }

    /**
     * This is a kind of game loop
     * controls are updated, a frame is requested based on a tick
     * the visualization parameter is a callback function
     * and its context is this (or subclassed method of) the component
     * 
     * It handles lag
     * @see http://www.gameprogrammingpatterns.com/game-loop.html for learning more!
     * 
     * @param visualization 
     * @param tick 
     */
    loop(visualization, tick = 0) {
        if (this.running == true) {
            tick = this.tick;
            // first measure
            this.currentTime = Date.now();
            this.elapsedTime = this.currentTime - this.previousTime;
            this.previousTime = this.currentTime;
            this.lag += this.elapsedTime;
            this.lagWarning = '';

            if (this.lag > this.TICK_RATE) {
                this.lagWarning = 'lagging';
                if (this.debugMode === true) {
                    console.info('[SvgAnimationComponent] lag detected:', this.lag, 'where tick rate is', this.TICK_RATE);
                }
            }
            if (this.debugMode === true) {
                console.log('currentTime is at', this.currentTime);
                console.log('previousTime is at', this.previousTime);
                console.log('elapsedTime is at', this.elapsedTime);
                console.log('lag is at', this.lag);
            }

            this.handleInputs();

            while (this.lag >= this.TICK_RATE) {
                this.doUpdate(visualization, tick);
                this.lag -= this.TICK_RATE;
            }

            this.doRender(visualization, tick);
        }

        requestAnimationFrame(() => {
            this.loop(visualization, tick);
        });
    }

    handleMarginLeft() {
        if (
            typeof this.frameObjects !== 'undefined' &&
            typeof this.frameObjects[this.counter] !== 'undefined' &&
            typeof this.frameObjects[this.counter].styles !== 'undefined' &&
            typeof this.frameObjects[this.counter].styles.marginLeft !== 'undefined'
        ) {
            this.marginLeft = (this.marginLeft + this.frameObjects[this.counter].styles.marginLeft);
        }
    }

    handleMarginTop() {
        if (
            typeof this.frameObjects !== 'undefined' &&
            typeof this.frameObjects[this.counter] !== 'undefined' &&
            typeof this.frameObjects[this.counter].styles !== 'undefined' &&
            typeof this.frameObjects[this.counter].styles.marginTop !== 'undefined'
        ) {
            this.marginTop = (this.marginTop + this.frameObjects[this.counter].styles.marginTop);
        }
    }

    handleTransform() {
        if (
            typeof this.frameObjects !== 'undefined' &&
            typeof this.frameObjects[this.counter] !== 'undefined' &&
            typeof this.frameObjects[this.counter].styles !== 'undefined' &&
            typeof this.frameObjects[this.counter].styles.transform !== 'undefined'
        ) {
            this.transform = (this.frameObjects[this.counter].styles.transform);
        }
    }

    /**
     * Decoupled render method
     * 
     * @param visualization 
     * @param tick 
     */
    doRender(visualize, tick) {
        this.tick += 1;
        if (this.tick % this.modulo === 0 || this.tick === 0) {
            if (this.debugMode === true){ 
                console.log('modulo!', this.tick, this.modulo);
            }
            this.handleMarginLeft();
            this.handleMarginTop();
            this.handleTransform();
            this.counter += 1;
        }
        if (this.counter === this.frameObjects.length) {
            this.counter = this.startCount;
            this.transform = 'rotateY(0deg)';
        }
        // would handle lag
        requestAnimationFrame((tick) => {
            this.requestUpdate();
            let viz = visualize.bind(this);
            viz();
        })
    }

    render() {
        let template = html`
        <div class="row"> 
            <div class="svg-animation-component-container col-6">
                <div class="frame-counter">
                    frame: ${this.counter}
                </div>
                <img 
                src="${this.styleSheetPrefix}${this.asset}"
                class="img-fluid svg-animation-asset"
                style="transform: ${this.transform}; margin-left: ${this.marginLeft}%; margin-top: ${this.marginTop}%;"
                style=""
                />
            </div>
        </div>
        `;

        return template;
    }

    handleInputs() {
        if (this.debugMode === true) {
            console.log('handleInputs');
        }
        // would process input(s)
    }

    doUpdate(visualization, tick) {
        if (this.debugMode === true) {
            console.log('doUpdate...', tick);
        }
    }

    firstUpdated() {
        this.handleWrapperClick();
        this.running = true;
    }

    handleWrapperClick() {
        console.log('[SvgAnimationComponent handleWrapperClick]');
        this.loop(this.visualize);
    }

    /**
     * visualize, called about every 1/60th of a second if possible
     */
    visualize() {
        this.asset = this.frameObjects[this.counter].asset;
    }
}

//register the component with the window custom elements registry
window.customElements.define('uutje-404-svg-animation-component', Uutje404SvgAnimationComponent);